<!--
 * @Author: your name
 * @Date: 2020-09-08 09:37:08
 * @LastEditTime: 2022-10-20 17:19:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\blockRegister\list.vue
-->
<template>
    <div class="commonTableStyles blockRegister">
        <van-nav-bar
            title="试块登记"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
        >
            <div class="warpper">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                    <ul class="list">
                        <template v-for="(item,index) in orderList">
                            <li :key="`orderList_${index}`" @click="toBlockList(item)">
                                <div class="engineeringInfo">
                                    <h4 class="engineeringInfo_header">
                                        <span class="headerName">任务编号：{{ item.task_number }}</span>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <span class="info">工程名称：{{ item.project_name }}</span>
                                        </p>
                                        <p>
                                            <span class="info">客户名称：{{ item.customer_name }}</span>
                                        </p>
                                        <p>
                                            <span class="info">工程地址：{{ item.project_address }}</span>
                                        </p>
                                        <p>
                                            <van-row>
                                                <van-col span="12">
                                                    <span class="info">生产机组：{{ item.line_name }}</span>
                                                </van-col>
                                                <van-col span="12">
                                                    <span class="info">强度等级：{{ item.strength_grade_name }}</span>
                                                </van-col>
                                            </van-row>
                                        </p>
                                        <p>
                                            <span class="info">附加型号：{{ item.special_require_name }}</span>
                                        </p>
                                        <p>
                                            <span class="info">计划方量：{{ item.plan_quantity }}</span>
                                        </p>
                                        <p>
                                            <van-row>
                                                <van-col span="12">
                                                    <span class="info">试块组数：{{ item.test_block_group }}</span>
                                                </van-col>
                                                <van-col span="12">
                                                    <span class="info">试块数：{{ item.test_block }}</span>
                                                </van-col>
                                            </van-row>
                                        </p>
                                        <p>
                                            <van-row>
                                                <van-col span="12">
                                                    <span class="info">施工部位：{{ item.place_name }}</span>
                                                </van-col>
                                                <van-col span="12">
                                                    <span class="info">工程类型：{{ item.project_type_name }}</span>
                                                </van-col>
                                            </van-row>
                                        </p>
                                        <p>
                                            <span class="info">用料时间：{{ item.arrival_time }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
    name: 'block-register-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'block-register-list');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            // 下拉刷新
            isLoading: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 试块列表
        toBlockList(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'blockRegisterChildlist', params: { data: data } });
        },
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getListPage();
        },
        async getListPage() {
            const res = await this.getListApi();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
        getListApi() {
            const queryStr = '?pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize;
            return this.$axios.$get('/interfaceApi/production/formulablockpressure/query_block_regist' + queryStr, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.blockRegister
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-pull-refresh__track
            height 100%
</style>